<template>
  <div class="products">
    <span id="c-add">
      <ProductsStockAdd
        v-if="showAdd"
        @showAdd="close"
        @showMore="showMore"
        :page="page"
        :id="id"
      />
    </span>
    <va-card :title="$t('stock.cards.title')">
      <template slot="actions">
        <va-button
          icon="fa fa-plus"
          href="#c-add"
          @click="create()"
        />
      </template>
      <va-data-table
        :fields="fields"
        :data="stock"
        :per-page="perPage"
        :totalPages="totalPages"
        :loading="loading"
        @page-selected="showMore"
        no-data-label="Sem Dados Cadastrados"
        api-mode
      >
      </va-data-table>
    </va-card>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import ProductsStockAdd from './ProductsStockAdd.vue'

const perPage = 10
export default {
  name: 'ProductsStock',
  components: { ProductsStockAdd },
  props: {
    id: {
      required: true,
    },
  },
  methods: {
    close (v) {
      this.showAdd = v
    },
    create () {
      this.showAdd = true
    },
    showMore (page) {
      this.loading = true
      this.page = page
      this.$apollo.queries.stock.fetchMore({
        variables: {
          page: (page - 1) * this.perPage,
          perPage: this.perPage,
          product_id: this.id,
        },
        updateQuery: (_, { fetchMoreResult }) => {
          this.loading = false
          return fetchMoreResult
        },
      })
    },
  },
  data () {
    return {
      stock: [],
      page: 1,
      perPage: perPage,
      pages: null,
      loading: false,
      showAdd: false,
    }
  },
  apollo: {
    stock: {
      query: gql`
      query MyQuery($perPage: Int!, $page: Int!, $product_id: Int!) {
        stock(limit: $perPage, offset: $page, order_by: {id: desc}, where: {product_id: {_eq: $product_id}}) {
          id
          qtd
          product {
            name
            id
          }
        }
      }
      `,
      variables () {
        return {
          perPage,
          page: 0,
          product_id: this.id,
        }
      },
    },
    pages: {
      query: gql`
      query MyQuery($product_id: Int!) {
         pages:  stock_aggregate(where: {product_id: {_eq: $product_id}}) {
          aggregate {
            count
          }
        }
      }
      `,
      variables () {
        return {
          product_id: this.id,
        }
      },
    },
  },
  computed: {
    totalPages () {
      return this.pages != null ? Math.ceil(this.pages.aggregate.count / this.perPage) : 0
    },
    fields () {
      return [
        {
          name: 'id',
          title: this.$t('stock.headings.id'),
        },
        {
          name: 'product.name',
          title: this.$t('stock.headings.product'),
        },
        {
          name: 'qtd',
          title: this.$t('stock.headings.amount'),
          dataClass: 'text-center',
          titleClass: 'text-center',
        },
      ]
    },
  },
  mounted () {
    if (Object.keys(this.$apollo.queries).includes('stock')) {
      this.$apollo.queries.pages.refetch()
      this.$apollo.queries.stock.refetch()
    }
  },
}
</script>

<style lang="scss">
</style>
